/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AccuracyStatsResponse } from '../models/AccuracyStatsResponse';
import type { BiasMetrics } from '../models/BiasMetrics';
import type { EstimateCreate } from '../models/EstimateCreate';
import type { EstimateListResponse } from '../models/EstimateListResponse';
import type { EstimateResponse } from '../models/EstimateResponse';
import type { EstimateUpdate } from '../models/EstimateUpdate';
import type { RecordOutcome } from '../models/RecordOutcome';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class EstimatesService {
    /**
     * Get Accuracy Stats
     * Get overall accuracy statistics for the user.
     *
     * Returns bias metrics showing systematic tendencies in predictions.
     * @returns AccuracyStatsResponse Successful Response
     * @throws ApiError
     */
    public static getAccuracyStatsApiV1EstimatesAccuracyGet(): CancelablePromise<AccuracyStatsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/estimates/accuracy',
        });
    }
    /**
     * Get Ticker Accuracy
     * Get bias metrics for a specific ticker.
     *
     * Returns the user's prediction accuracy for this ticker based on
     * historical estimates with recorded outcomes.
     *
     * Requires at least 2 completed estimates for this ticker.
     * @returns BiasMetrics Successful Response
     * @throws ApiError
     */
    public static getTickerAccuracyApiV1EstimatesAccuracyTickerGet({
        ticker,
    }: {
        ticker: string,
    }): CancelablePromise<BiasMetrics> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/estimates/accuracy/{ticker}',
            path: {
                'ticker': ticker,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Fill Pending Outcomes
     * Trigger auto-fill of actuals from FMP for pending estimates.
     *
     * Fetches actual EPS/revenue values for estimates where:
     * - earnings_date has passed
     * - actual_value is still NULL
     *
     * This is also run automatically by the daily scheduler.
     * @returns any Successful Response
     * @throws ApiError
     */
    public static fillPendingOutcomesApiV1EstimatesFillOutcomesPost(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/estimates/fill-outcomes',
        });
    }
    /**
     * Create Estimate
     * Create a new estimate for an upcoming earnings report.
     *
     * User can predict EPS or Revenue before earnings are announced.
     * After earnings, use the /outcome endpoint to record actual results.
     * @returns EstimateResponse Successful Response
     * @throws ApiError
     */
    public static createEstimateApiV1EstimatesTickerPost({
        ticker,
        requestBody,
    }: {
        ticker: string,
        requestBody: EstimateCreate,
    }): CancelablePromise<EstimateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/estimates/{ticker}',
            path: {
                'ticker': ticker,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Estimates For Ticker
     * Get estimate history for a specific ticker.
     *
     * Returns all estimates for the ticker sorted by earnings date (newest first).
     * @returns EstimateListResponse Successful Response
     * @throws ApiError
     */
    public static getEstimatesForTickerApiV1EstimatesTickerGet({
        ticker,
        limit = 20,
    }: {
        ticker: string,
        limit?: number,
    }): CancelablePromise<EstimateListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/estimates/{ticker}',
            path: {
                'ticker': ticker,
            },
            query: {
                'limit': limit,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Update Estimate
     * Update an estimate (only allowed before actual value is recorded).
     * @returns EstimateResponse Successful Response
     * @throws ApiError
     */
    public static updateEstimateApiV1EstimatesEstimateIdPatch({
        estimateId,
        requestBody,
    }: {
        estimateId: number,
        requestBody: EstimateUpdate,
    }): CancelablePromise<EstimateResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v1/estimates/{estimate_id}',
            path: {
                'estimate_id': estimateId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Delete Estimate
     * Delete an estimate.
     * @returns any Successful Response
     * @throws ApiError
     */
    public static deleteEstimateApiV1EstimatesEstimateIdDelete({
        estimateId,
    }: {
        estimateId: number,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/estimates/{estimate_id}',
            path: {
                'estimate_id': estimateId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Record Outcome
     * Record the actual earnings result for an estimate.
     *
     * This computes deviation percentages and marks the estimate as complete.
     * @returns EstimateResponse Successful Response
     * @throws ApiError
     */
    public static recordOutcomeApiV1EstimatesEstimateIdOutcomePost({
        estimateId,
        requestBody,
    }: {
        estimateId: number,
        requestBody: RecordOutcome,
    }): CancelablePromise<EstimateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/estimates/{estimate_id}/outcome',
            path: {
                'estimate_id': estimateId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
